import { useQuery } from '@tanstack/react-query'
import { automationApi } from '../../api/automation.api'
import { Badge } from '../../components/ui/Badge'
import { EmptyState } from '../../components/ui/EmptyState'

export function AutomationLogsPanel({ ruleId }: { ruleId: string }) {
  const logsQuery = useQuery({ queryKey: ['automation', ruleId, 'logs'], queryFn: async () => (await automationApi.logs(ruleId)).data })

  if (!logsQuery.data || logsQuery.data.length === 0) {
    return <EmptyState mascot mascotSize={48} title="Noch keine Ausführungen" description="Diese Regel wurde noch nicht ausgelöst." />
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      {logsQuery.data.map((log) => (
        <div key={log.id} style={{ fontSize: 'var(--text-xs)', display: 'flex', gap: 6, alignItems: 'baseline' }}>
          <Badge variant={log.success ? 'success' : 'danger'}>{log.success ? 'OK' : 'Fehler'}</Badge>
          <span style={{ color: 'var(--text-muted)' }}>{new Date(log.createdAt).toLocaleString('de-DE')}</span>
          <span>{log.actionsExecuted.map((a) => a.detail).join('; ') || log.error}</span>
        </div>
      ))}
    </div>
  )
}
